import React, { useEffect, useState, useCallback } from 'react';
import * as api from '../api';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [, setPagination] = useState({ total: 0, limit: 50, offset: 0 });
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', bodyText: '', type: 'general', targetAudience: 'all' });
  const [saving, setSaving] = useState(false);

  const fetchNotifications = useCallback(async (offset = 0) => {
    setLoading(true);
    try {
      const params = { limit: '50', offset: String(offset) };
      if (statusFilter) params.status = statusFilter;
      const data = await api.getNotifications(params);
      setNotifications(data.notifications);
      setPagination(data.pagination);
    } catch { /* ignore */ } finally { setLoading(false); }
  }, [statusFilter]);

  useEffect(() => { fetchNotifications(0); }, [fetchNotifications]);

  const handleCreate = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.createNotification(form);
      setShowForm(false);
      setForm({ title: '', bodyText: '', type: 'general', targetAudience: 'all' });
      fetchNotifications(0);
    } catch { /* ignore */ } finally { setSaving(false); }
  };

  const handleSend = async (notif) => {
    if (!window.confirm(`Send "${notif.title}" to ${notif.targetAudience} users?`)) return;
    try {
      const result = await api.sendNotification(notif.id);
      alert(`Notification sent to ${result.sentTo} users.`);
      fetchNotifications(0);
    } catch { /* ignore */ }
  };

  return (
    <div>
      <div className="page-header">
        <h1>Notifications</h1>
        <p>Manage and send push notifications</p>
      </div>

      <div className="toolbar">
        <select className="filter-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">All statuses</option>
          <option value="draft">Draft</option>
          <option value="scheduled">Scheduled</option>
          <option value="sent">Sent</option>
        </select>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ New notification'}
        </button>
      </div>

      {showForm && (
        <form className="card" style={{ marginBottom: 20 }} onSubmit={handleCreate}>
          <div className="form-group">
            <label>Title</label>
            <input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea style={{ width: '100%', minHeight: 80, padding: 10, border: '1px solid #e0e0e0', borderRadius: 8, fontFamily: 'inherit', fontSize: 14 }} value={form.bodyText} onChange={(e) => setForm({ ...form, bodyText: e.target.value })} required />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div className="form-group">
              <label>Type</label>
              <select className="filter-select" style={{ width: '100%' }} value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                <option value="general">General</option>
                <option value="update">Update</option>
                <option value="promotion">Promotion</option>
                <option value="alert">Alert</option>
              </select>
            </div>
            <div className="form-group">
              <label>Target Audience</label>
              <select className="filter-select" style={{ width: '100%' }} value={form.targetAudience} onChange={(e) => setForm({ ...form, targetAudience: e.target.value })}>
                <option value="all">All Users</option>
                <option value="active">Active Users</option>
                <option value="new">New Users (7 days)</option>
              </select>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Creating...' : 'Create draft'}
          </button>
        </form>
      )}

      {loading ? (
        <div className="loading">Loading notifications...</div>
      ) : notifications.length === 0 ? (
        <div className="empty-state"><p>No notifications yet.</p></div>
      ) : (
        <div className="card">
          <div className="table-container">
            <table>
              <thead><tr><th>Title</th><th>Type</th><th>Audience</th><th>Status</th><th>Sent To</th><th>Created</th><th>Actions</th></tr></thead>
              <tbody>
                {notifications.map((n) => (
                  <tr key={n.id}>
                    <td style={{ fontWeight: 500 }}>{n.title}</td>
                    <td><span className="badge badge-gray">{n.type}</span></td>
                    <td style={{ fontSize: 13 }}>{n.targetAudience}</td>
                    <td><span className={`badge badge-${n.status === 'sent' ? 'green' : n.status === 'scheduled' ? 'blue' : 'yellow'}`}>{n.status}</span></td>
                    <td>{n.sentCount || '—'}</td>
                    <td style={{ fontSize: 13, color: '#888' }}>{new Date(n.createdAt).toLocaleDateString('en-ZA')}</td>
                    <td>
                      {n.status !== 'sent' && (
                        <button className="btn btn-sm btn-primary" onClick={() => handleSend(n)}>Send</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
